import React, { useState } from 'react';
import { Box, Paper, Typography, List, ListItem, ListItemText, ListItemIcon, Chip, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem } from '@mui/material';
import { Build, CheckCircle, Pending } from '@mui/icons-material';

const Maintenance: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [requests] = useState([
    { id: '1', title: 'Broken light in parking', status: 'pending', priority: 'medium' },
    { id: '2', title: 'Leaking tap unit 3', status: 'in-progress', priority: 'high' },
    { id: '3', title: 'Garden maintenance', status: 'completed', priority: 'low' }
  ]);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">Maintenance Requests</Typography>
        <Button variant="contained" onClick={() => setOpen(true)}>New Request</Button>
      </Box>
      <Paper>
        <List>
          {requests.map(r => (
            <ListItem key={r.id} divider>
              <ListItemIcon>{r.status === 'completed' ? <CheckCircle color="success" /> : <Pending color="warning" />}</ListItemIcon>
              <ListItemText primary={r.title} />
              <Chip label={r.priority} size="small" color={r.priority === 'high' ? 'error' : 'default'} />
            </ListItem>
          ))}
        </List>
      </Paper>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>New Request</DialogTitle>
        <DialogContent><TextField fullWidth label="Title" margin="normal" /><TextField fullWidth label="Description" multiline rows={3} margin="normal" /></DialogContent>
        <DialogActions><Button onClick={() => setOpen(false)}>Cancel</Button><Button variant="contained" onClick={() => setOpen(false)}>Submit</Button></DialogActions>
      </Dialog>
    </Box>
  );
};
export default Maintenance;
